// extracted by mini-css-extract-plugin
export var addToCartButton = "_r0-b";
export var arrowButtonContainer = "_r0-9";
export var arrowButtonIcon = "_r0-a";
export var carouselArrowButton = "_r0-6";
export var carouselElementContainer = "_r0-1";
export var left = "_r0-7";
export var productDisplayCarouselContainer = "_r0-0";
export var productTileContainer = "_r0-2";
export var productTileImage = "_r0-4";
export var productTileImageContainer = "_r0-3";
export var productTileTitle = "_r0-5";
export var right = "_r0-8";
export var sliderOverflow = "_r0-c";